.select2-dropdown {
    background-color: $input-bg;
    color: $input-color;
}

.select2-container--default .select2-results__option[aria-selected=true] {
  background-color: $select2-container-bg-selected;
  color: $select2-container-fg-selected;
}

.select2-container--default .select2-results__option--highlighted {
  background-color: $select2-container-hover-bg !important;
  color: $select2-container-hover-fg !important;
}

.select2-container--default .select2-selection--multiple {
    background-color: $input-bg;
    color: $input-color;


}

.select2-container--default .select2-selection--multiple .select2-selection__choice {
  background-color: $tree-bg-selected;
  color: $tree-fg-selected;
  border: $input-border-width solid $dropdown-link-hover-bg;
  line-height: 2;

  & .select2-selection__choice__remove {
    color: $dropdown-link-remove-color;
    margin-right: 0.25rem;
  }
}

.select2-container--default .select2-search--inline .select2-search__field {
    background: transparent none repeat scroll 0% 0%;
    border: medium none;
    outline: 0px none;
    box-shadow: none;
    width: 100% !important;
}

.select2-container--default .select2-search__field {
    background-color: $input-bg;
    color: $input-color;
}

.renderable > .select2-container {
    width: 100% !important;
}

.select2-container .select2-selection--single  {
  height: auto;
  min-height: 28px;
  background-color: $input-bg;
  & .select2-selection__rendered{
    line-height: inherit;
    padding: $input-padding-y $input-padding-x;
    padding-right: 1.5rem;
    color: $input-color;
  }
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
  top: 0px;
  height: 100%;
}

.select2-container--default.select2-container--focus {
  & .select2-selection--single,
  & .select2-selection--multiple {
    border-color: $input-focus-border-color !important;
    outline: 0;
    -webkit-box-shadow: $input-focus-box-shadow;
    box-shadow: $input-focus-box-shadow;
  }
}


.select2-results span.wcTabIcon {
  padding-left: 20px;
}

.select2-selection {
  color: $input-color;
  background-color: $input-bg;
  background-clip: padding-box;
  border: $input-border-width solid $input-border-color !important;
}

.select2-container--default.select2-container--disabled .select2-selection--multiple {
    background-color: $input-disabled-bg !important;
    opacity: 1;
    color: $text-muted;
}

.select2-container--default.select2-container--disabled .select2-selection--single {
    background-color: $input-disabled-bg !important;
    opacity: 1;
    color: $text-muted;
}

.select2-container--default.select2-container--disabled .select2-selection__rendered {
  color: $text-muted;
}

.select2-select-all-adapter-container {
  padding: 3px 0px;
  background-color: $color-primary;
  margin-bottom: 3px;
}

/* select2 readonly */
select[readonly].select2-hidden-accessible + .select2-container {
    pointer-events: none;
    touch-action: none;
}

select[readonly].select2-hidden-accessible + .select2-container .select2-selection {
    background: $select2-readonly;
    color: $text-muted;
    box-shadow: none;
}

select[readonly].select2-hidden-accessible + .select2-container .select2-selection__arrow, select[readonly].select2-hidden-accessible + .select2-container .select2-selection__clear {
    display: none;
}
